import React from 'react';
import {
  ContentElementInterview as CeInterviewDefault,
  type ContentElementInterviewProps,
} from '@vgn-medien-holding/vgn-fe-components';
import elementStyle from './styles/default';

export default function ContentElementInterview(element: ContentElementInterviewProps['element']) {
  return <CeInterviewDefault element={element} classProps={elementStyle} />;
}
